import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';

import { BaseWidget } from '@website-builder/widgets/base/base-widget';
import { SocialStyle } from '@website-builder/widgets/social/model/social-style';
import { SocialElement } from '@website-builder/widgets/social/social-element';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class SocialWidget extends BaseWidget<SocialStyle> {
  readonly type = BuilderElementType.Social;
  style = new SocialStyle();

  elements = [new SocialElement('https://www.facebook.com', 'mdi:facebook')];

  static normalizeInPlace(widget: SocialWidget): SocialWidget {
    const pureWidget = new SocialWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.elements = (widget.elements ?? pureWidget.elements).map(element => SocialElement.normalizeInPlace(element));

    widget.style = SocialStyle.normalize(widget.style);

    return widget;
  }
}
